import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { eventsApi } from "@/lib/humhub-api/events";
import { queryInvalidationHelpers } from "@/lib/queryInvalidationHelpers";

interface UseDeleteEventReturn {
  isLoading: boolean;
  error: Error | null;
  deleteEvent: (
    eventId: number,
    scope?: "single" | "future" | "all",
  ) => Promise<void>;
}

export const useDeleteEvent = (): UseDeleteEventReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      eventId,
      scope,
    }: {
      eventId: number;
      scope?: "single" | "future" | "all";
    }) => {
      return eventsApi.deleteEvent(eventId, scope);
    },
    onSuccess: () => {
      // イベント関連クエリを無効化してリフレッシュ
      queryInvalidationHelpers.invalidateEventQueries(queryClient);
    },
    onError: (error) => {
      console.error("Error deleting event:", error);
    },
  });

  const deleteEvent = useCallback(
    async (
      eventId: number,
      scope: "single" | "future" | "all" = "single",
    ): Promise<void> => {
      return mutation.mutateAsync({ eventId, scope });
    },
    [mutation],
  );

  return {
    isLoading: mutation.isPending,
    error: mutation.error,
    deleteEvent,
  };
};
